import {Card,Form} from '@deere/ux.uxframe-react'
import {React, useEffect, useState} from 'react'
import {getAnswerLabel, getTranslation, findAnswerIndex} from '../../utils/utils'
import { QUESTION_PROPRIETARY } from '../../utils/surveyLiterals'
import PropiertaryInfReview from './PropiertaryInfReview'
import { getCountry } from '../../services/external.service';
import { useOktaAuth } from '@okta/okta-react';


export default function LaborReviewSection({sectionSurvey,answers}) {
    const [countries,setCountries] =  useState([]);
    const { authState } = useOktaAuth();

    useEffect(() => {
        try {
            if(countries.length <=0){
                getCountry(authState.accessToken.accessToken).then(resp=>{
                    if (resp.length !== 0) {
                        setCountries([...resp]);
                    }
                });
            }
        } catch (err) {
            console.log(err);
        }
    }, []);

    if(!sectionSurvey)
        return <></>

        
    const questions = sectionSurvey.questions.filter(qu => qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1)
    const propQuestion = sectionSurvey.questions.filter(qu => qu.text === QUESTION_PROPRIETARY)[0];
    
    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, answers) >= 0 ? answers[findAnswerIndex(propQuestion.id, answers)].answer : '' : '';
    const createDependentRow = (question,index) => {
        let label = getAnswerLabel(question,answers);
        if(question.type === 'OPTION_CTY' && countries.length > 0){
            const country = countries.find(it=>it.iso2CountryCode === label);
            if(country){
                label = country.name;
            }
        }

        return label === '-'?null:<Form.Row key={index}>
                    <Form.Group className='mb-4 pl-4'>
                        <Form.Label className="uxf-label">{getTranslation(question,'text')}</Form.Label>
                        <h6>{label}</h6>
                    </Form.Group>
                </Form.Row>
    }

    return (<div>        
            {propComments? <PropiertaryInfReview section={sectionSurvey} answer={propComments}/>:null} 
            {!propComments?<Card>
                <Card.Body>
                <Card.Title className='pb-3'>
                    {getTranslation(sectionSurvey, 'description')}
                </Card.Title>
                {
                    questions.map((question,idx) =>  {
                        if(question.idQuestionDepends) {
                            return createDependentRow(question,idx)
                        }

                        return <Form.Row key={idx}>
                            <Form.Group>
                                <Form.Label className="uxf-label">{getTranslation(question,'text')}</Form.Label>
                                {
                                    question.dependentQuestions.map( quest => {
                                        return <><br/>
                                            <Form.Label className="uxf-label">{getTranslation(quest,'text')}</Form.Label>
                                            <h6>{getAnswerLabel(quest, answers)}</h6>
                                        </>
                                    })
                                }
                                {
                                    (question.dependentQuestions && 
                                        question.dependentQuestions.length === 0) && 
                                            <h6>{getAnswerLabel(question,answers)}</h6>
                                }
                            </Form.Group>
                        </Form.Row>
                    })
                }
                </Card.Body>
            </Card>:null
            }
        </div>)
}   